import { notNull } from "./utils"

export const mixpanelEndpointMap = {
   track: 'update',
   engage: 'id',
   groups: 'groups',
} as const

export type MixpanelEndpoint = keyof typeof mixpanelEndpointMap
export type MixpanelProxyEndpoint = typeof mixpanelEndpointMap[MixpanelEndpoint]

export function encodeMixpanelEndpoint(mixpanelEndpoint: MixpanelEndpoint) {
   return mixpanelEndpointMap[mixpanelEndpoint] as MixpanelProxyEndpoint
}

export function decodeMixpanelEndpoint(mixpanelProxyEndpoint: MixpanelProxyEndpoint) {
   return notNull(Object.entries(mixpanelEndpointMap).find(([, value]) => value === mixpanelProxyEndpoint))[0] as MixpanelEndpoint
}
